import axios from 'axios';
import { CONFIG } from '../../../../../environments';

const { endpoints } = window.HONDAPS_FIND_AND_COMPARE_FOOTER;

const axiosInstance = axios.create({
  baseURL: CONFIG.ENDPOINT,
});

const getTrimDetails = async (trimId, colorId) => {
  try {
    const response = await axiosInstance.get(endpoints.getTrimDetails, { params: { model: trimId } });
    if (response.data.success) {
      const {result} = response.data;
      const selectedColor = result.colors.find((color) => color.mfgColorCode === colorId) || result.colors[0];
      return { ...result, selectedColor };
    }
    throw new Error('Failed to fetch trim details');
  } catch (error) {
    throw new Error('Failed to fetch trim details');
  }
};

export {
  getTrimDetails,
};